import { Leaf, Hand, Ruler, Sparkles } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, Eyebrow } from "@/components/Reveal";

const ITEMS = [
  { key: "a", Icon: Leaf },
  { key: "b", Icon: Hand },
  { key: "c", Icon: Ruler },
  { key: "d", Icon: Sparkles },
];

const WhyUs = () => {
  const { t } = useLang();

  return (
    <section className="relative py-16 md:py-32 px-6 md:px-12 bg-card border-y border-border">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="max-w-2xl mb-16">
            <Eyebrow>{t("why.badge")}</Eyebrow>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl text-foreground leading-tight">
              {t("why.title")}
            </h2>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {ITEMS.map(({ key, Icon }, i) => (
            <Reveal key={key} delay={i * 0.08}>
              <div className="group h-full border-t border-gold/30 pt-7">
                <span className="inline-flex items-center justify-center w-14 h-14 border border-gold/30 rounded-sm text-gold group-hover:bg-gold group-hover:text-black transition-colors duration-300">
                  <Icon size={24} strokeWidth={1.4} />
                </span>
                <h3 className="mt-6 font-serif text-2xl text-foreground">{t(`why.items.${key}.title`)}</h3>
                <p className="mt-3 text-sm text-muted-foreground font-sans leading-relaxed">
                  {t(`why.items.${key}.desc`)}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
